export class Rotation {
    value: number
}